import { useCallback, useRef } from 'react'
import { AuthStatus, init } from '@thoughtspot/visual-embed-sdk'

import useGetThoughtSpotTokenQuery from '../../api/queries/useGetThoughtSpotTokenQuery'
import { createThoughtSpotConfig } from '../utils/config'

export const useInitializeThoughtSpot = (userId: string | undefined) => {
  const initializedRef = useRef(false)
  const { data: token } = useGetThoughtSpotTokenQuery(userId)

  const initializeThoughtSpot = useCallback(() => {
    if (initializedRef.current) {
      return
    }

    const config = createThoughtSpotConfig(token)
    const eventEmitter = init(config)

    if (eventEmitter && token) {
      eventEmitter
        .on(AuthStatus.SUCCESS, () => (initializedRef.current = true))
        .on(AuthStatus.SDK_SUCCESS, () => (initializedRef.current = true))
        .on(AuthStatus.FAILURE, () => (initializedRef.current = false))
    }
  }, [token])

  if (!token) {
    return
  }

  initializeThoughtSpot()
}
